import type { ReactElement } from "react";
import { useTranslations } from "@/lib/i18n/intl";
import type { SellerTransactionStatus } from "@/lib/api/types";
import {
  getTransactionStatusLabel,
  getTransactionStatusTone,
} from "@/modules/transactions/lib/transaction-display";

/**
 * Status pill for a payment transaction. Follows the order status-pill pattern:
 * tinted background + coloured dot + an always-present text label, so status is
 * never conveyed by colour alone.
 */
export function TransactionStatusPill({
  status,
}: {
  status: SellerTransactionStatus;
}): ReactElement {
  const t = useTranslations();
  const tone = getTransactionStatusTone(status);

  return (
    <span
      className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full px-[9px] py-[3px] text-[11px] font-semibold"
      style={{ background: tone.bg, color: tone.fg }}
    >
      <span
        aria-hidden="true"
        className="h-[5px] w-[5px] rounded-full"
        style={{ background: tone.fg }}
      />
      {getTransactionStatusLabel(t, status)}
    </span>
  );
}
